import React, {Component} from 'react';
import './App.css';
import {Form, Input, Radio, Button} from 'element-react';
import 'element-theme-default';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import md5 from 'js-md5';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        token: '',
        target: '',
        size: '0',
        type: '0',
        password: ''
      },
      copied: false
    };
    this.rules = {
        token: { required: true, message: 'token不能为空', trigger: 'blur' },
        target: { required: true, message: 'target不能为空', trigger: 'blur' }
    };

    let lowerAlpha = this.characterRange('a', 'z')
    let upperAlpha = this.characterRange('A', 'Z')
    let number = this.characterRange('0', '9')
    let other = String('`~!@#$%^&*()-_=+[{]}\\|;:\'",<.>/?')

    this.whitelist = [...(lowerAlpha+upperAlpha+number).split('')].map(i => i.charCodeAt(0))
    this.whitelistExt = [...(lowerAlpha+upperAlpha+number+other).split('')].map(i => i.charCodeAt(0))
    this.number = [...number.split('')].map(i => i.charCodeAt(0))
  }

  range(size, startAt = 0) {
    return [...Array(size).keys()].map(i => i + startAt);
  }

  characterRange(startChar, endChar) {
    return String.fromCharCode(
      ...this.range(endChar.charCodeAt(0) - startChar.charCodeAt(0) + 1, startChar.charCodeAt(0)))
  }

  md5rawlist(token, target) {
    let t1 = md5(token)
    let t2 = md5(target)
    let result = []
    for (let i=0; i < t1.length; i+=2) {
      result.push( (parseInt(t1.slice(i,i+2), 16) + parseInt(t2.slice(i,i+2), 16)) % 255 )
    }
    return result
  }

  filter(rawlist, filterlist) {
    let psw = String()
    for (let i in rawlist) {
      if (filterlist.indexOf(rawlist[i]) !== -1) {
        psw += String.fromCharCode(rawlist[i])
      } else {
        psw += String.fromCharCode(filterlist[rawlist[i] % filterlist.length])
      }
    }
    return psw
  }

  selector(psw, size) {
    if (size === 0) {
      return psw
    } else {
      return psw.slice(0, size)
    }
  }

  gen(token, target, size) {
    let rawlist = this.md5rawlist(token, target)
    return this.selector(this.filter(rawlist, this.whitelist), parseInt(size))
  }

  genNum(token, target, size) {
    let rawlist = this.md5rawlist(token, target)
    return this.selector(this.filter(rawlist, this.number), parseInt(size))
  }

  genExt(token, target, size) {
    let rawlist = this.md5rawlist(token, target)
    return this.selector(this.filter(rawlist, this.whitelistExt), parseInt(size))
  }

  onChangeToken(value) {
    let newState = this.state
    newState.form.token = value
    this.setState(newState);
  }

  onChangeTarget(value) {
    let newState = this.state
    newState.form.target = value
    this.setState(newState);
  }

  onChangeType(value) {
    let newState = this.state
    newState.form.type = value
    this.setState(newState);
  }

  onChangeSize(value) {
    let newState = this.state
    newState.form.size = value
    this.setState(newState);
  }

  handleSubmit(event) {
    event.preventDefault();

    this.refs.form.validate((valid) => {
      if (valid) {
        let t = this.state.form.type
        let s = this.state.form.size
        let newState = this.state
        if (t === '0') {
          newState.form.password = this.gen(this.state.form.token, this.state.form.target, s)
        } else if (t === '1') {
          newState.form.password = this.genNum(this.state.form.token, this.state.form.target, s)
        } else if (t === '2') {
          newState.form.password = this.genExt(this.state.form.token, this.state.form.target, s)
        } else {
          newState.form.password = ''
        }
        if (newState.form.password !== '') {
          this.setState(newState)
        }
        return true;
      } else {
        return false;
      }
    });
  }

  render() {
    return (
      <Form ref="form" model={this.state.form} labelWidth="80" rules={this.rules}>
        <Form.Item prop="token" label="token">
          <Input value={this.state.form.token} onChange={this.onChangeToken.bind(this)}></Input>
        </Form.Item>
        <Form.Item prop="target" label="target">
          <Input value={this.state.form.target} onChange={this.onChangeTarget.bind(this)}></Input>
        </Form.Item>
        <Form.Item label="type">
          <Radio.Group onChange={this.onChangeType.bind(this)}>
            <Radio value="0" checked={this.state.form.type === '0'}>常用</Radio>
            <Radio value="1" checked={this.state.form.type === '1'}>数字</Radio>
            <Radio value="2" checked={this.state.form.type === '2'}>扩展</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="size">
          <Radio.Group onChange={this.onChangeSize.bind(this)}>
            <Radio value="0" checked={this.state.form.size === '0'}>不限</Radio>
            <Radio value="6" checked={this.state.form.size === '6'}>6位</Radio>
            <Radio value="8" checked={this.state.form.size === '8'}>8位</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={this.handleSubmit.bind(this)}>generate</Button>
        </Form.Item>
        <Form.Item label="password">
          <Input value={this.state.form.password}></Input>
          <CopyToClipboard text={this.state.form.password} onCopy={() => this.setState({copied: true})}>
            <span>Click to copy to clipboard</span>
          </CopyToClipboard>
        </Form.Item>
      </Form>
    )
  }
}

export default App;
